import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshArrows = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.333 2.66602V6.66602H11.333",
			stroke: "white",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.666992 13.334V9.33398H4.66699",
			stroke: "white",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.34033 6.00038C2.67844 5.0449 3.25308 4.19064 4.01064 3.51732C4.76819 2.844 5.68397 2.37355 6.67252 2.14988C7.66106 1.92621 8.69016 1.9566 9.66379 2.23823C10.6374 2.51985 11.5238 3.04352 12.2403 3.76038L15.3337 6.66704M0.666992 9.33371L3.76033 12.2404C4.47682 12.9572 5.36324 13.4809 6.33686 13.7625C7.31049 14.0441 8.33959 14.0745 9.32813 13.8509C10.3167 13.6272 11.2325 13.1568 11.99 12.4834C12.7476 11.8101 13.3222 10.9559 13.6603 10.0004",
			stroke: "white",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRefreshArrows;
